import React from 'react';
import { Grid } from '../../../components/Grid';
import { TagField, TextField } from '../../../components';
import { useFormikContext } from 'formik';
import { ISearchOrdersSpecificationData } from '../types/ISearchOrdersSpecification';

interface IDefaultOrdersSearchFormProps {}

const findDuplicateFileNumbers = (fileNumbers: string[] | undefined | null) => {
  if (fileNumbers === null || fileNumbers === undefined) return [];
  return fileNumbers.filter((e, i, a) => a.indexOf(e) !== i);
};

export const DefaultOrdersSearchForm: React.FC<IDefaultOrdersSearchFormProps> = () => {
  const formik = useFormikContext();
  const values: ISearchOrdersSpecificationData = formik.values as ISearchOrdersSpecificationData;
  const duplicates = findDuplicateFileNumbers(values.fileNumbers);
  const errorText = duplicates.length > 0 ? `You have duplicate order number(s): ${duplicates.join(', ')}` : undefined;
  return (
    <Grid templateColumns="3fr 3fr 3fr 1fr">
      {/* Allow alphanumeric characters and common file number separators (dash, underscore) */}
      <TagField errorText={errorText} name="fileNumbers" placeholder="Search for files" regExp={/[^a-zA-Z0-9\-_]/g} />
      <TextField name="partyName" placeholder="Search for a name - buyer, borrower or seller" />
      <TextField name="streetAddress" placeholder="Search for street address" />
      <TextField name="unit" placeholder="Unit #" />
    </Grid>
  );
};
